import { render, staticRenderFns } from "./Step4ConfirmConfig.vue?vue&type=template&id=343c7eb0&scoped=true"
import script from "./Step4ConfirmConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./Step4ConfirmConfig.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Step4ConfirmConfig.vue?vue&type=style&index=0&id=343c7eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c7eb0",
  null
  
)

export default component.exports